var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/rotate.aae7dfb9.png","uri@2x": __webpack_public_path__ + "static/media/rotate.87f59744.png","uri@3x": __webpack_public_path__ + "static/media/rotate.dd694504.png",
    width: 22,
    height: 19
});